import React, { Component } from "react";
import SingleToggle from "./SingleToggle";
// reactstrap components
import { FormGroup, Label, Input, Row, Col } from "reactstrap";

export default class PlatformQuestion extends Component {
  displayContent() {
    return (
      <Row className='PQ_Content'>
        {this.props.content.categories.map((category, cIndex) => {
          return <Col md={6} lg={4} className="mb-3" key={`pq_content_${cIndex}`}>{this.displayCategory(category, cIndex)}</Col>;
        })}
      </Row>
    );
  }

  displayCategory(category, cIndex) {
    return (
      <div className='PQ_Category' key={`${this.props.name}_category_${cIndex}`}>
        <p className='font-weight-bold'>{category.text}</p>
        {category.subcategories.map((subcategory, sIndex) => {
          return this.displaySubcategory(subcategory, sIndex);
        })}
      </div>
    );
  }

  displaySubcategory(subcategory, sIndex) {
    if (subcategory.type === "singleToggle") {
      return (
        <SingleToggle
          handleChange={(name, newValue) => {
            console.log("here...");
            console.log(`${name} with ${newValue}`);
            this.props.handleChange(name, newValue);
          }}
          label={subcategory.text}
          name={subcategory.key}
          currentValue={subcategory.currentValue === true}
          key={`subcategory_${subcategory.key}`}
          useBottomBorder={false}
          // error={thisQuestionError}
        />
      );
    } else if (subcategory.type === "string") {
      return (
        <FormGroup key={`subcategory_${subcategory.key}`} className='mb-2'>
          <Label htmlFor={subcategory.key}>{subcategory.text}</Label>
          <Input
            type={"text"}
            className='form-control'
            id={subcategory.key}
            name={subcategory.key}
            placeholder={subcategory.placeholder}
            value={subcategory.currentValue != null ? subcategory.currentValue : ""}
            onChange={(e) => {
              this.props.handleChange(subcategory.key, e.target.value);
            }}
          />
        </FormGroup>
      );
    } else {
      return (
        <div className='PQ_Subcategory' key={`subcategory_${subcategory.key}`}>
          <strong>{subcategory.key} had no valid type</strong>
        </div>
      );
    }
  }

  render() {
    return (
      <div className='pt-3 border-top'>
        <p className='font-weight-bold mb-4'>{this.props.qIndex}. {this.props.label}</p>

          {this.displayContent()}

        {typeof this.props.error !== "undefined" && Object.keys(this.props.error).length !== 0 && <div className='text-danger mb-3'>Please select at least 1 option</div>}
      </div>
    );
  }
}
